import Button from "../baseComponents/Button/Button";
import ButtonWitchMenu from './ButtonWitchMenu';

import {useDispatch, useSelector} from 'react-redux';

import './style.css'
import {Checkbox} from "@mui/material";
import UserSvg from "../../icons/User";
import EllipseSvg from "../../icons/EllipseSvg";
import ReportSvg from "../../icons/Details";
import RouteSvg from "../../icons/Route";
import ExcelSvg from "../../icons/ExcelSvg";
import ScheduleSvg from "../../icons/Schedule";
import {setSelectedGeoObjArray} from "../../actions/ui";
import {useHistory} from "react-router-dom";
import {mapStateToProps} from "./mapStateToProps";
import {periodTypes} from "../../const";
import {memo} from "react";
import {getCriteria} from "../../shared/helpers/getCriteria";
import {getShortNameOfGeoobjectByTitle} from "../../shared/helpers/getShortNameOfGeoobjectByTitle";

function InfoObject(props) {
    const {className = '', svg, bgColorClass, title, actionCheckBox, key_item, printReport} = props

    const { isActive } = useSelector((state)=>{
        const isActive = (state?.ui?.selectedGeoObjArray || []).includes(key_item);
        return {isActive}
    })

    const history = useHistory();
    const dispatch = useDispatch()

    const {
        selectedGeoObj,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
        geoObjRoute,
        geoObjReportExcel,
        getGeoObjRoute,
        loadRoute,
        getGeoObjReportExcel,
        selectedGeoObjArray,
    } = useSelector(mapStateToProps);

    let rangeNamer;
    if (dateRangeCriteria === periodTypes.TODAY) {
        rangeNamer = 'за сегодня'
    } else if (dateRangeCriteria === periodTypes.WEEK) {
        rangeNamer = 'за неделю'
    } else if (dateRangeCriteria === periodTypes.PERIOD) {
        let gd;
        if (rangeStartDate?.getFullYear() !== rangeEndDate?.getFullYear()) {
            gd = (d) => `${d?.getDate()}.${(d?.getMonth() || 0) + 1}.${d?.getFullYear()}`
        } else if ((rangeStartDate?.getMonth() !== rangeEndDate?.getMonth()) || (rangeStartDate?.getDate() !== rangeEndDate?.getDate())) {
            gd = (d) => `${d?.getDate()}.${(d?.getMonth() || 0) + 1}`
        } else {
            gd = (d) => `${d?.getDate()}.${(d?.getMonth() || 0) + 1} ${d?.getHours()}:${d?.getMinutes()}`
        }
        rangeNamer = `${gd(rangeStartDate)}-${gd(rangeEndDate)}`

    }

    const criteria = getCriteria(
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate
    )

    const handleDetail = () => {
        dispatch(setSelectedGeoObjArray([key_item]))
        history.push('/doc2');
    }

    const handleRoute =() => {
        dispatch(setSelectedGeoObjArray([key_item]))
        if (geoObjRoute?.abort) geoObjRoute.abort();
        loadRoute({
            loadCriteria:{
                objId: key_item,
                criteria
            },
            naming:{
                rangeNamer,
                objId: key_item,
                name: title,
            }
        })
        history.push('/');
    }

    const handleExcel = () => {
        dispatch(setSelectedGeoObjArray([key_item]))
        if (geoObjReportExcel?.abort) geoObjReportExcel.abort();
        getGeoObjReportExcel({
            objId: key_item,
            criteria
        })
        history.push('/');
    }

    const handleReport = () => {
        dispatch(setSelectedGeoObjArray([key_item]))
        printReport && printReport()
    }

    return (
        <div className={`info ${className}`}>
            <div className="info-wrap">
                <Checkbox sx={{'& .MuiSvgIcon-root': {fontSize: 24}}}
                    onClick={() => actionCheckBox(key_item)}
                    checked={isActive}
                />
                <EllipseSvg />
                {svg || <UserSvg/>}
                {/*<div className={`info__clip ${bgColorClass}`}></div>*/}
                <div className={"object-title"}>{ getShortNameOfGeoobjectByTitle(title)}</div>
            </div>

            <div className={"info-actions"}>

                <Button
                    className="info-actions-btn"
                    children={<ReportSvg/>}
                    title={'Детализация'}
                    onClick={handleDetail}
                />

                <Button
                    className="info-actions-btn"
                    children={<RouteSvg/>}
                    title={'Маршрут'}
                    onClick={handleRoute}
                />

                <Button
                    className="info-actions-btn"
                    children={<ExcelSvg/>}
                    title={'Скачать Excel'}
                    onClick={handleExcel}
                />

                <Button
                    className="info-actions-btn"
                    children={<ScheduleSvg/>}
                    title={'Скачать табель'}
                    onClick={handleReport}
                />

                <ButtonWitchMenu
                    handleDetail={handleDetail}
                    handleRoute={handleRoute}
                    handleExcel={handleExcel}
                    rangeNamer={rangeNamer}
                />
            </div>
        </div>
    )
};

export default memo(InfoObject);
